itsoftApp.createModule("linksHeader", function () {
    const module = this;

    const LinksHeader = function () {
        this.elements = document.querySelectorAll('.main-menu__link');
        this.el = document.querySelector('.js-border-link');


        if (this.elements.length > 0 && this.el) {
            this.init();
        }
    }

    LinksHeader.prototype.init = function () {
        const THIS = this;

        THIS.bindMethods();
        THIS.addListeners();
    }

    LinksHeader.prototype.bindMethods = function () {
        const THIS = this;

        THIS.onMouseEnter = THIS.onMouseEnter.bind(THIS);
        THIS.onMouseLeave = THIS.onMouseLeave.bind(THIS);
    }

    LinksHeader.prototype.addListeners = function () {
        const THIS = this;

        for (let index = 0; index < THIS.elements.length; index++) {
            const el = THIS.elements[index];
            el.addEventListener('mouseenter', THIS.onMouseEnter);
            el.addEventListener('mousemove', THIS.onMouseEnter);
            el.addEventListener('mouseleave', THIS.onMouseLeave);
        }
    }

    LinksHeader.prototype.onMouseEnter = function (e) {
        const THIS = this;

        const target = e.currentTarget;
        const rect = target.getBoundingClientRect();
        const width = rect.width;
        const top = rect.top;
        const left = rect.left;

        THIS.el.style.width = width + 'px';
        THIS.el.style.transform = `translate(${left}px, ${top}px)`;

        target.classList.add('_active');
        THIS.el.classList.add('_active');


    }

    LinksHeader.prototype.onMouseLeave = function (e) {
        const THIS = this;

        const target = e.currentTarget

        target.classList.remove('_active');
        THIS.el.classList.remove('_active');

    }


    new LinksHeader();
    module.callback = LinksHeader;
});